import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/shared/components/component-base';
import { GeneralRequestService } from '../../services/general-request.service';
import { GeneralRequestDto } from '../../models/general-request-models';

@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: ['./request-details.component.css']
})
export class RequestDetailsComponent extends BaseComponent implements OnInit {
  formObj: GeneralRequestDto = {} as GeneralRequestDto;
  requestId: string;

  constructor(
    private generalRequestService: GeneralRequestService,
    private route: ActivatedRoute
  ) {
    super();
    this.initBreadcrumb();
  }

  ngOnInit(): void {
    this.requestId = this.route.snapshot.params['id'];
    if (this.requestId) {
      this.loadRequest();
    }
  }

  initBreadcrumb() {
    this.pageTitle = this.translate.instant("workflow.requestDetails");
    this.breadcrumbItems = [
      { label: this.translate.instant("approvalsHistory.title"), url: "/common/approvals-history", isActive: false },
      { label: this.pageTitle, isActive: true }
    ];
  }

  loadRequest() {
    this.generalRequestService.getById(this.requestId).subscribe({
      next: (response) => {
        if (response.success) {
          this.formObj = response.value;
        } else {
          // If not found, try getting by approval request ID
          this.loadByApprovalRequestId();
        }
      },
      error: (error) => {
        console.error(error);
        this.toastrService.error(this.translate.instant('common.errorContent'));
      }
    });
  }

  loadByApprovalRequestId() {
    this.generalRequestService.getByApprovalRequestId(this.requestId).subscribe({
      next: (response) => {
        if (response.success) {
          this.formObj = response.value;
        } else {
          this.toastrService.error(response.message || this.translate.instant('common.errorContent'));
        }
      },
      error: (error) => {
        console.error(error);
        this.toastrService.error(this.translate.instant('common.errorContent'));
      }
    });
  }
}
